import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type SaveWorkflowRuleDefinitionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.WorkflowRuleDefinitionInput;
}>;

export type SaveWorkflowRuleDefinitionMutationResult = { __typename?: 'Mutation' } & {
  saveWorkflowRuleDefinition?: GraphQLTypes.Maybe<
    { __typename?: 'SaveWorkflowRuleDefinitionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      workflowRuleDefinition?: GraphQLTypes.Maybe<
        { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
          GraphQLTypes.WorkflowRuleDefinitionType,
          'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
        > & {
            ruleInputFields: Array<
              { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
            >;
            ruleOutputFields: Array<
              { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
            >;
          }
      >;
    }
  >;
};

export const SaveWorkflowRuleDefinitionDocument = gql`
  mutation saveWorkflowRuleDefinition($input: WorkflowRuleDefinitionInput!) {
    saveWorkflowRuleDefinition(input: $input) {
      errors {
        message
        path
      }
      workflowRuleDefinition {
        id
        ruleDefinitionTag
        ruleDescription
        ruleInputFields {
          component
          label
          name
        }
        ruleName
        ruleOutputFields {
          component
          label
          name
        }
      }
    }
  }
`;
